<template>
  <div class="container-fluid">
    <div class="row mb-3">
      <div class="col-12">
        <h1>Users</h1>
        <hr>
      </div>
    </div>

    <UsersList

    />
  </div>
</template>

<script>
  import UsersList from './users/UsersList'

  export default {
    components: {
      UsersList,
    },
  }
</script>

<style>

</style>
